import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CustomQuestion, JoiEvent } from 'globals/store/events.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Dictionary } from '@ngrx/entity';
import { makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { CustomAnswerColumnData, SurveyResponseColumnData, customAnswerColumns } from '../../helpers/table-column-types';
import { TableColumn } from '../../helpers/table.data';
import { saveTable } from '../../modules/performers/performerSharedFunctions';
import { NestedTableComponent } from '../../components/nested-table/nested-table.component';
import { surveyResponsesTableReselector } from '../../store/reselectors/apps.reselector';

@Component({
    selector: 'survey-responses-table',
    template: `
<nested-table 
  *ngIf="columns?.length"
  [items]="items"
  [columns]="columns"
  [columnsById]="columnsById"
  [readOnly]="true"
  [defaultSelectedColumnId]="columns[0].id"
  [emptyMessage]="'No responses'"
></nested-table>
`,
    standalone: true,
    imports: [NestedTableComponent],
})
export class SurveyResponsesTableComponent extends Wrapper<SurveyResponsesTableComponent> implements OnInit {
  @Input() surveyId: string
  @Input() appId: string
  event: JoiEvent
  readOnly: boolean = true
  items: SurveyResponseColumnData[] = []
  customAnswerColumns = customAnswerColumns
  columns: TableColumn[] = []
  columnsById: Dictionary<TableColumn> = {}

  @ViewChild(NestedTableComponent) nestedTable: NestedTableComponent<CustomAnswerColumnData>

  exportTable() {
    saveTable(`Evaluation form responses` ,`${this.event.title} evaluation form responses`, this.dialog, this.nestedTable, 'export-table')
  }

  ngOnInit() {
    this.selectCallback<{ columns: TableColumn[], items: SurveyResponseColumnData[], questions: CustomQuestion[] }, any>(surveyResponsesTableReselector, { surveyId: this.surveyId, appId: this.appId }, (data) => {
      if (!data) return
      this.columns = data.columns
      this.columnsById = makeMapFromListOfObjectsAndKey(this.columns, 'id')
      this.items = data.items
    })
    this.subProp(this.store.select('events','event'), 'event')
    this.uiService.changePageTitle(`Evaluation Form Responses`, true)
    setTimeout(() => console.log(this), 3000)
  }


}